import { EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
var CasePracticeTeamQuestionComponent = (function () {
    function CasePracticeTeamQuestionComponent(commonService, apiService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.onGoToBegin = new EventEmitter();
        this.onGoToVideo = new EventEmitter();
        this.assetsRoute = "../../assets";
    }
    CasePracticeTeamQuestionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.recordArray = [0, 0, 0, 0, 0];
        this.optionArray = ['信任', '承诺', '沟通', '流程', '结果'];
        this.selectable = true;
        this.correctShow = false;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/diagnosis',
            'data': {}
        }).subscribe(function (result) {
            _this.questions = result.questions;
            _this.currentNumber = result.number == result.questions.length ? result.number : result.number + 1;
            if (_this.currentNumber == result.questions.length) {
                _this.selectable = false;
                // this.questionShow = false;
                setTimeout(function () {
                    // $('#reviewBtn').hide();
                    $('#questionsContent').hide();
                    $('#text').hide();
                    $('#questionShowWrap').hide();
                    $('#quesiton').hide();
                    $('#nextStep').fadeIn();
                }, 300);
                _this.recordArray[_this.getCurrentCorrectOptionIndex()] = 1;
            }
            else {
                _this.questionShow = true;
            }
        });
        /*this.questions = this.getMockData().questions;
        this.currentNumber = 1;*/
    };
    CasePracticeTeamQuestionComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
    };
    CasePracticeTeamQuestionComponent.prototype.onItemClick = function (i, event) {
        var _this = this;
        if (this.selectable) {
            // 回答正确
            if (this.optionArray[i] == this.questions[this.currentNumber - 1].option) {
                this.submitAnswer(i, this.questions[this.currentNumber - 1].id);
                this.recordArray[i] = 1;
                $("#question").hide();
                // 显示正确
                // $("#corret").show();
                this.selectable = false;
                this.correctShow = true;
                setTimeout(function () {
                    if (_this.currentNumber < _this.questions.length) {
                        // 只有还需答题才有动画
                        _this.questionShow = false;
                        setTimeout(function () {
                            _this.currentNumber++;
                            _this.resetStatus();
                        }, 1000);
                    }
                    else {
                        _this.recordArray = [0, 0, 0, 0, 0];
                        _this.questionShow = false;
                        $('#text').fadeOut(200);
                        setTimeout(function () {
                            $('#nextStep').fadeIn(200);
                        }, 500);
                    }
                }, 1000);
            }
            else {
                // 震动
                for (var iter = 0; iter < 6; iter++) {
                    $(event.target).animate({ left: (iter % 2 == 0 ? '-=0.5rem' : '+=0.5rem') }, 100);
                }
                // 回答错误
                this.recordArray[i] = 9;
                if (this.checkWrongRecord()) {
                    this.submitAnswer(i, this.questions[this.currentNumber - 1].id);
                    this.selectable = false;
                    this.recordArray[this.getCurrentCorrectOptionIndex()] = 10;
                    setTimeout(function () {
                        if (_this.currentNumber < _this.questions.length) {
                            setTimeout(function () {
                                _this.questionShow = false;
                            }, 1500);
                            setTimeout(function () {
                                _this.currentNumber++;
                                _this.resetStatus();
                            }, 3000);
                        }
                        else {
                            _this.recordArray = [0, 0, 0, 0, 0];
                            _this.questionShow = false;
                            $('#text').fadeOut(200);
                            setTimeout(function () {
                                $('#nextStep').fadeIn(200);
                            }, 500);
                        } // end of if currentNumber < this.question.lengh
                    }, 1000); // end of set timeout
                } // end of checkWrongRecord
            } // end of check option
        } // end of selectable
    }; // end of onItemClick
    CasePracticeTeamQuestionComponent.prototype.submitAnswer = function (i, qid) {
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/diagnosis/finish',
            'data': {
                'selectors': this.optionArray[i],
                'question_id': qid
            }
        }).subscribe(function (result) { });
    }; // end of submitAnswer
    CasePracticeTeamQuestionComponent.prototype.resetStatus = function () {
        this.recordArray = [0, 0, 0, 0, 0];
        this.selectable = true;
        // $("#correct").hide();
        this.questionShow = true;
        // 在滑动后展示问题, 设置正确
        $('#questionWrap').css({ "-webkit-transform": "translateX(100%)", "transform": "translateX(100%)" });
        $('#question').show();
        this.correctShow = false;
        $('#questionWrap').css({ "-webkit-transform": "translateX(0)", "-webkit-transition": "0.5s linear", "transform": "translateX(0)", "transition": "0.5s linear" });
    }; // end of resetStatus
    CasePracticeTeamQuestionComponent.prototype.checkWrongRecord = function () {
        return this.recordArray.filter(function (r) { return r == 9; }).length >= 3 ? true : false;
    }; // end of checkWrongRecord
    CasePracticeTeamQuestionComponent.prototype.getCurrentCorrectOptionIndex = function () {
        var _this = this;
        return this.optionArray.findIndex(function (o) { return o == _this.questions[_this.currentNumber - 1].option; });
    }; // end of getCurrentCorrectOptionIndex
    CasePracticeTeamQuestionComponent.prototype.goToBegin = function () {
        this.onGoToBegin.emit(true);
        this.apiService.ajax({
            'type': 'post',
            'url': '/sr/onceino/402',
            'data': {}
        }).subscribe(function (result) { });
    };
    CasePracticeTeamQuestionComponent.prototype.goToVideo = function () {
        this.onGoToVideo.emit('question');
    };
    return CasePracticeTeamQuestionComponent;
}());
export { CasePracticeTeamQuestionComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-team-question/case-practice-team-question.component.ts.pre-build-optimizer.js